<form class="form" [formGroup]="form" (submit)="onSubmit()">
  <div class="fields">
    <app-login-email-field [form]="form"></app-login-email-field>
    <app-login-password-field [form]="form"></app-login-password-field>
    <div class="fields">
      <button type="submit" class="button button-primary" [disabled]="form.invalid" translate>auth.login.button</button>
    </div>
    <p class="recover-link" translate>auth.login.message <a [routerLink]="['/recover-password']" translate>auth.login.recoverPassword</a></p>
  </div>
</form>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/login/login-form/login-form.component.html